require("@PayseraCurrencyExchangeBundle/Resources/less/currency-exchange.less");

require("@root/assets/js/toast/toast.module.js");
require("@root/assets/js/toast/services/messageResolver.js");
require("@root/assets/js/toast/services/errorExtractor.js");
require("@root/assets/js/toast/services/successMessageExtractor.js");
require("@root/assets/js/toast/services/toastDispatcher.js");
require("@root/assets/js/toast/services/toastDispatcherCreator.js");
require("@root/assets/js/toast/services/toastInterceptor.js");
require("@root/node_modules/ng-toast/dist/ngToast.js");

import angular from 'angular';
import payseraEnvironment from '@root/assets/js/module/paysera-environment/app';

require("imports-loader?define=>false,exports=>false!@root/node_modules/raven-js/dist/plugins/angular.js");
require("@root/assets/js/raven/angular-plugin.js");

import ngRoute from 'angular-route';
import ngSanitize from 'angular-sanitize';
import appRouting from './app.routing';
import currencyExchangeControllers from './controller/module';
import payseraTranslator from '@root/assets/js/module/paysera-translator/app';
import appConfig from './app.config';
import appRun from './app.run';
import currencyExchangeTable from './currency-exchange/app';

export default angular
    .module('paysera.currency_exchange', [
        ngRoute,
        payseraEnvironment,
        payseraTranslator,
        currencyExchangeControllers,
        currencyExchangeTable,
        ngSanitize,
        'paysera.toast'
    ])
    .config(appRouting)
    .config(appConfig)
    .run(appRun)
;

if (Raven !== undefined && Raven.isSetup()) {
    angular
        .module('paysera.currency_exchange')
        .requires.push('ngRaven')
    ;
}
